import { createSlice, PayloadAction } from "@reduxjs/toolkit";


let agentType:string='weather';
const agentSlice = createSlice({
  name: "agentObject",
  initialState: agentType,
  reducers: {
    setAgentType: (
      _,
      action: PayloadAction<string>
    ) => {
     return action.payload;
    },


  },
});


export default agentSlice.reducer;
export const { setAgentType} = agentSlice.actions;